export default "__VITE_ASSET__BKqUVwY8__"